import React from 'react';

const Loading = ({ placeholder = 'Cargando...', classNameDiv='', classNameInput=''}) => {

    const cssClassDiv = `${classNameDiv} sg-input`;
    const cssClassInput = `${classNameInput} sg-input-field`;

    return (
        <div className={cssClassDiv}>
            <input className={cssClassInput} type='text' placeholder={placeholder} disabled/>
        </div>
    );
}

export default Loading;
